import {
    AfterContentInit,
    ChangeDetectorRef,
    Component, ContentChildren, EventEmitter, Input,
    OnDestroy,
    Output,
    QueryList,
    ViewChildren
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Objects } from 'src/modules/utils/shared/objects';
import { CdPausedDirective } from '../../directives/cd-paused.directive';
import { SmTabComponent } from '../sm-tab/sm-tab.component';
import { TabPanel } from 'primeng/tabs';


@Component({
    selector: 'sm-tab-view',
    standalone: false,
    templateUrl: './sm-tab-view.component.html',
    styleUrls: ['./sm-tab-view.component.scss']
})
export class SmTabViewComponent implements AfterContentInit, OnDestroy {
    @Input() value: string;
    @Output() valueChange = new EventEmitter<string>();
    @Output() onCloseTab = new EventEmitter<string>();

    @ContentChildren(SmTabComponent) tabChildren!: QueryList<SmTabComponent>;

    @ViewChildren(CdPausedDirective) pausers!: QueryList<CdPausedDirective>;

    @ViewChildren(TabPanel) tabPanels!: QueryList<TabPanel>;

    tabs: TabVM[] = [];
    private sub?: Subscription;

    constructor(private cdr: ChangeDetectorRef) {}

    ngAfterContentInit(): void {
        this.rebuildTabs();

        this.sub = this.tabChildren.changes.subscribe(() => {
            this.rebuildTabs();
            this.cdr.markForCheck();
        });
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }

    tabs2(): TabVM[] {
        this.rebuildTabs();
        return this.tabs;
    }

    private rebuildTabs(): void {
        const arr = this.tabChildren?.toArray() ?? [];
        this.tabs = arr.map((t, i) => ({
            value: Objects.toString(t.value ?? i),
            header: t.header,
            tabClass: t.tabClass,
            disabled: t.disabled,
            closable: t.closable,
            contentTpl: t.contentTpl
        }));

        if (this.tabs.length) {
            const exists = this.tabs.some(t => t.value === this.value);
            if (!exists) {
                this.value = this.tabs[0].value;
                this.valueChange.emit(this.value);
            }
        } 
        else {
            this.value = null;
        }
    }

    onChange(v: string | number): void {
        this.value = Objects.toString(v);
        this.valueChange.emit(this.value);
    }

    close(tabValue: string, ev: MouseEvent): void {
        ev.stopPropagation();
        this.onCloseTab.emit(tabValue);
    }

    trackByVal = (_: number, t: TabVM): string => t.value;

    navigateToElement(el: HTMLElement): void {
        for(const panel of this.tabPanels.toArray()) {
            if(panel.el.nativeElement.contains(el)) {
                this.onChange(panel.value());
                return;
            }
        }
    }
}

interface TabVM {
    value: string;
    header?: string;
    tabClass: string;
    disabled: boolean;
    closable: boolean;
    contentTpl: any;
}
